<template>
  <!--  -->
  <form class="pt-16" @submit.prevent="update">
    <!--  -->
    <section class="bg-gray-100 bg-opacity-50 p-2 h-screen w-full relative" style="z-index: 50;">
      <!--  -->
      <div class="mx-auto container max-w-5xl bg-gray-300 shadow-md">
        <!--  -->
        <div class="bg-gray-100 p-4 border-t-4 bg-opacity-5 border-green-500  rounded-t" >
          <!--  -->
          <div class="max-w-sm mx-auto md:w-full md:mx-0">
            <!--  -->
            <div class="inline-flex items-center space-x-4">
              <!--  -->
              <img class="w-10 h-10 object-cover rounded-full" alt="User avatar" :src="`https://avatars.jakerunzer.com/${user.email}`" />
              <!--  -->

              <!--  -->
              <h1 class="text-gray-700 font-semibold capitalize"></h1>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="bg-white space-y-6">
          <!--  -->
          <div class="md:inline-flex md:space-y-0 w-full p-2 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">{{ $t('email') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">mail</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <span class="p-2">{{ user.email }}</span>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">{{ $t('role') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">lock</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.role.name" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="role" disabled />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500"> {{ $t('fullname') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">person</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.fullName" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="fullName" />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500"> {{ $t('phone') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border-2 border-green-700" >
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">phone</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.phone" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="phone" required />
                <!--  -->
              </div>
            <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500"> {{ $t('username') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">person</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.username" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="username" @keydown.space="event => event.preventDefault()" @keydown="nameKeydown($event)" :disabled="isDisabled" />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="user.type != 'SubUser'" class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">{{ $t('store') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">business</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.company" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="company" required />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="user.type == 'TeleConsultant'" class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500"> {{ $t('publicName') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">public</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.publicName" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" :placeholder="$t('publicName')"/>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="user.type == 'Seller'" class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500"> {{ $t('city') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border-2 border-green-700" >
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">location_city</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.city" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="City" required />
                <!--  -->
              </div>
            </div>
            <!--  -->
            
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">
                {{ $t('Adresse de ramassage') }}
              </label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border-2 border-green-700" >
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">location_city</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.address" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="Address" />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="user.type == 'Seller'" class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">{{ $t('Postal Code') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border-2 border-green-700" >
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">fiber_manual_record</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.PostalCode" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="Postal Code" required />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
            
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <!--  -->
              <label class="text-sm text-gray-500">{{ $t('rib') }}</label>
              <!--  -->

              <!--  -->
              <div class="w-full rounded-md inline-flex border">
                <!--  -->
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <!--  -->
                  <i class="material-icons px-1">call_to_action</i>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="text" v-model="user.rib" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="Rib" required />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->

          <!--  -->
          <div class="md:inline-flex w-full space-y-4 md:space-y-0 justify-center text-gray-600 items-center" >
            <!--  -->
            <span class="text-gray-700 font-semibold">
              {{ $t('change_password') }}
            </span>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->

          <!--  -->
          <div class="md:inline-flex w-full space-y-4 md:space-y-0 p-4 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2" >
              <!--  -->
              <div class="w-full inline-flex border-b hover:border-orange-500 ">
                <!--  -->
                <div class="w-1/12 pt-2">
                  <!--  -->
                  <svg fill="none" class="w-6 text-gray-500 mx-auto" viewBox="0 0 24 24" stroke="currentColor" >
                    <!--  -->
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    <!--  -->
                  </svg>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="password" v-model="user.password" class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4" placeholder="New password" />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
            
            <!--  -->
            <div class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2" >
              <!--  -->
              <div class="w-full inline-flex border-b hover:border-orange-500 ">
                <!--  -->
                <div class="w-1/12 pt-2">
                  <!--  -->
                  <svg fill="none" class="w-6 text-gray-500 mx-auto" viewBox="0 0 24 24" stroke="currentColor" >
                    <!--  -->
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    <!--  -->
                  </svg>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <input type="password" v-model="user.confirmPassword" class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4" placeholder="Confirm password" />
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->
          
          <!--  -->
          <div class="md:inline-flex w-full space-y-4 justify-center md:space-y-0 p-2 text-gray-600 items-center" >
            <!--  -->
            <div class="md:w-3/12 text-center md:pl-6 pb-8">
              <!--  -->
              <button class="text-white w-full mx-auto max-w-sm rounded text-center bg-primary-600  py-2 px-8 inline-flex items-center focus:outline-none md:float-right" >
                <!--  -->
                <i class="material-icons mr-8">save </i>
                <!--  -->
                {{ $t('save') }}
                <!--  -->
              </button>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <div v-if="user.status == 'inactive'" class="ml-20 mr-20 pb-20">
            <!--  -->
            <div class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300" >
              <!--  -->
              <div class="alert-icon flex items-center bg-yellow-100 border-2 border-yellow-500 justify-center h-10 w-10 flex-shrink-0 rounded-full" >
                <!--  -->
                <span class="text-yellow-500">
                  <!--  -->
                  <svg fill="currentColor" viewBox="0 0 20 20" class="h-6 w-6">
                    <!--  -->
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" ></path>
                    <!--  -->
                  </svg>
                  <!--  -->
                </span>
                <!--  -->
              </div>
              <!--  -->
              
              <!--  -->
              <div class="alert-content ml-4">
                <!--  -->
                <div class="alert-title font-semibold text-lg text-yellow-800">
                  {{ $t('warning') }}
                </div>
                <!--  -->
                
                <!--  -->
                <div class="alert-description text-sm text-yellow-600">
                  {{ $t('must_shange_pass') }}
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </section>
    <!--  -->
  </form>
  <!--  -->
</template>

<script>
import DivFilter from '../components/DivFilter.vue';

export default {
  components: { DivFilter },
  name: 'Profil',
  data() {
    return {
      user: {
        role: {},
      },
      isDisabled: false,
      show: false,
    };
  },
  async mounted() {
    this.token = this.$jwtService.verifyToken();
    await this.getUser();
  },
  methods: {
    async getUser() {
      const { content } = await this.$server.me('users');
      if (content) {
        this.isDisabled = !!content.username;
        this.user = content;
      }
    },
    showBar() {
      this.show = !this.show;
    },
    async update() {
      const confirmed = await this.$confirm('Are you sure?');
      if (!confirmed) return;

      if (this.user.type === 'Seller') {
        if (!this.user.rib) {
          alert('Rib required!', 'warning');
          return;
        }

        if (isNaN(this.user.rib)) {
          alert(this.$t('rib_number'), 'warning');
          return;
        }
        
        if (!this.user.company) {
          alert('Store name required!', 'warning');
          return;
        }
      }

      if (this.user.password) {
        this.user.password = this.user.password.trim();
      }

      if (this.user.confirmPassword) {
        this.user.confirmPassword = this.user.confirmPassword.trim();
      }

      if (this.user.status === 'inactive' && this.user.password) {
        if (!this.checkPassword()) return;

        this.user.status = 'active';
      }

      const endpoint = this.user.type === 'SubUser' ? 'groups' : 'users';
      const response = await this.$server.update(endpoint, this.user);

      if (response._id || (response.content && response.content._id)) {
        alert('Profile updated', 'success');
        this.user.password = '';
        this.user.confirmPassword = '';

        if (this.user.status === 'inactive') {
          this.logout();
        } else {
          this.$router.go();
        }
      }
    },
    checkPassword() {
      if (this.user.password === this.user.confirmPassword) return true;

      alert('Confirmation password does not match', 'warning');
      return false;
    },
    checkData() {
      return !!this.user.email;
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = '/';
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.icon::after {
  content: '';
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
</style>
